import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import qs from 'qs';

import { Alert, Button } from 'components/Common';
import { LoginLayout } from 'components';

export class ResetPassword extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    status: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      password: '',
      passwordConfirmation: '',
      isMismatch: false,
      isTooShort: false
    };
  }

  handleChangeInput = event => {
    const { name, value } = event.target;

    this.setState({ [name]: value });
  };

  handleSubmit = event => {
    event.preventDefault();

    this.setState({ isMismatch: false, isTooShort: false });

    if (this.state.password !== this.state.passwordConfirmation) {
      this.setState({ isMismatch: true });
      return;
    }

    if (this.state.password.length < 6) {
      this.setState({ isTooShort: true });
      return;
    }

    const { client_id, token, uid } = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true
    });

    this.props.onSubmit({
      password: this.state.password,
      passwordConfirmation: this.state.passwordConfirmation,
      client: client_id,
      token,
      uid
    });
  };

  renderErrors() {
    if (this.state.isMismatch) {
      return (
        <Alert
          description={this.props.t('login.resetPassword.errors.mismatch')}
        />
      );
    }

    if (this.state.isTooShort) {
      return (
        <Alert
          description={this.props.t('login.resetPassword.errors.tooShort')}
        />
      );
    }

    if (this.props.status.error) {
      return <Alert description={this.props.t('general.errors.default')} />;
    }

    return null;
  }

  render() {
    return (
      <LoginLayout
        title={this.props.t('login.resetPassword.title')}
        description={this.props.t('login.resetPassword.description')}
      >
        {this.renderErrors()}

        <form className="login__form" onSubmit={this.handleSubmit}>
          <label htmlFor="password">
            {this.props.t('login.resetPassword.form.password.label')}
          </label>
          <input
            name="password"
            type="password"
            placeholder={this.props.t(
              'login.resetPassword.form.password.placeholder'
            )}
            value={this.state.password}
            onChange={this.handleChangeInput}
          />

          <label htmlFor="passwordConfirmation">
            {this.props.t(
              'login.resetPassword.form.passwordConfirmation.label'
            )}
          </label>
          <input
            name="passwordConfirmation"
            type="password"
            placeholder={this.props.t(
              'login.resetPassword.form.passwordConfirmation.placeholder'
            )}
            value={this.state.passwordConfirmation}
            onChange={this.handleChangeInput}
          />

          <Button type="submit" full isLoading={this.props.status.isLoading}>
            {this.props.t('login.resetPassword.form.submit.label')}
          </Button>
        </form>
      </LoginLayout>
    );
  }
}

export default translate()(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/ResetPassword/ResetPassword.js